import { TourStep } from './GuidedTourTooltip';

/**
 * 引导步骤配置
 * 
 * 定义四个主要步骤：
 * 1. 区域绘制 - 定义绘图有效范围
 * 2. 墙面绘制 - 沿底图绘制墙体
 * 3. 家具添加 - 从家具库添加家具
 * 4. 3D预览 - 查看3D渲染效果
 * 
 * 使用翻译键，组件会自动从 i18next 获取翻译内容
 */
export const TOUR_STEPS: TourStep[] = [
  {
    id: 'area-drawing',
    title: 'tour.steps.area.title',
    description: 'tour.steps.area.description',
    tip: 'tour.steps.area.tip',
    targetSelector: '[data-tool="area"]',
    position: 'bottom',
  },
  {
    id: 'wall-drawing',
    title: 'tour.steps.wall.title',
    description: 'tour.steps.wall.description',
    tip: 'tour.steps.wall.tip',
    targetSelector: '[data-tool="wall"]',
    position: 'bottom',
  },
  {
    id: 'furniture-adding',
    title: 'tour.steps.furniture.title',
    description: 'tour.steps.furniture.description',
    tip: 'tour.steps.furniture.tip',
    targetSelector: '[data-tool="furniture"]',
    position: 'left',
  },
  {
    id: '3d-preview',
    title: 'tour.steps.preview.title',
    description: 'tour.steps.preview.description',
    tip: 'tour.steps.preview.tip',
    targetSelector: '[data-action="3d-preview"]',
    position: 'bottom',
  },
];

/**
 * 步骤完成条件配置
 */
export const STEP_COMPLETION_CONDITIONS = {
  areaDrawing: {
    check: (store: any): boolean => {
      // 条件：有有效区域（validArea）
      return !!(store.project?.mapConfig?.validArea && 
                 store.project?.mapConfig?.validArea?.length >= 3);
    },
    description: '已绘制区域',
  },
  wallDrawing: {
    check: (store: any): boolean => {
      // 条件：有至少一个墙体元素
      const currentFloor = store.currentFloor;
      if (!currentFloor || !currentFloor.layers) return false;
      const elements = currentFloor.layers.flatMap((l: any) => l.elements || []);
      return elements.some((el: any) => el.type === 'wall');
    },
    description: '已绘制墙面',
  },
  furnitureAdding: {
    check: (store: any): boolean => {
      // 条件：有至少一个家具元素（排除墙体、门、楼梯等结构元素）
      const currentFloor = store.currentFloor;
      if (!currentFloor || !currentFloor.layers) return false;
      const elements = currentFloor.layers.flatMap((l: any) => l.elements || []);
      return elements.some((el: any) => 
        el.type === 'model3d' || el.type === 'furniture'
      );
    },
    description: '已添加家具',
  },
  preview3D: {
    check: (store: any): boolean => {
      // 条件：打开了3D预览
      return store.isPreviewOpen === true;
    },
    description: '已查看3D预览',
  },
};

/**
 * 步骤对应的图片目录
 */
export const STEP_IMAGE_DIRS: Record<string, { demo: string; guide: string; result: string }> = {
  'area-drawing': {
    demo: '/tour-images/area-drawing/demo.gif',
    guide: '/tour-images/area-drawing/guide.png',
    result: '/tour-images/area-drawing/result.png',
  },
  'wall-drawing': {
    demo: '/tour-images/wall-drawing/demo.gif',
    guide: '/tour-images/wall-drawing/guide.png',
    result: '/tour-images/wall-drawing/result.png',
  },
  'furniture-adding': {
    demo: '/tour-images/furniture-adding/demo.gif',
    guide: '/tour-images/furniture-adding/guide.png',
    result: '/tour-images/furniture-adding/result.png',
  },
  '3d-preview': {
    demo: '/tour-images/3d-preview/demo.gif',
    guide: '/tour-images/3d-preview/guide.png',
    result: '/tour-images/3d-preview/result.png',
  },
};

export default TOUR_STEPS;
